import React, { useState, useEffect } from 'react';
import { Card, PageControls } from 'components';
import { getAltTagFromFileName, slugify } from 'utils';
import styled from 'styled-components';

function Cards({
  products,
  imageWidth,
  imageHeight,
  currentPage,
  setCurrentPage,
  productsPerPage = 12
}) {
  const [paginatedProducts, setPaginatedProducts] = useState([]);

  useEffect(() => {
    const indexOfLastProduct = currentPage * productsPerPage;
    const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
    const _paginatedProducts = products.slice(indexOfFirstProduct, indexOfLastProduct);
    setPaginatedProducts(_paginatedProducts);
  }, [products, currentPage]);

  return (
    paginatedProducts && (
      <Grid name="top-of-product-grid">
        {paginatedProducts.length ? (
          paginatedProducts.map((node) => {
            const { id, title, images, productVariants } = node;
            let slug;
            if (productVariants) {
              slug = `${slugify(title)}-${productVariants.default.productId.toLowerCase()}`;
            } else {
              slug = slugify(title);
            }
            const mainImage = images?.[0];
            return (
              <Card
                key={id}
                id={id}
                slug={slug}
                image={mainImage}
                imageWidth={imageWidth}
                imageHeight={imageHeight}
                title={title}
                alt={getAltTagFromFileName(mainImage?.asset?.originalFilename || '')}
              />
            );
          })
        ) : (
          <NoCards>
            There are currently no products to show for this filter.
            <br />
            Please select another.
          </NoCards>
        )}
        {products.length > productsPerPage && (
          <PageControls
            products={products}
            paginatedProducts={paginatedProducts}
            productsPerPage={productsPerPage}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        )}
      </Grid>
    )
  );
}

const Grid = styled.div`
  display: grid;
  grid-column: 1/-1;
  grid-row: 2;
  grid-template-columns: subgrid;
  margin-bottom: 100px;
  row-gap: 0.625rem;

  @media (width >= 48rem) {
    grid-column: 4/-1;
    grid-row: 1;
  }
`;

const NoCards = styled.h3`
  bottom: 0.188em;
  color: var(--connolly-black);
  font-size: 2rem;
  grid-column: 1 / -1;
  letter-spacing: 0.01em;
  position: relative;
  text-align: center;
  width: 100%;
`;

export default Cards;
